// extracted by mini-css-extract-plugin
module.exports = {"history-block":"HistoryBlock_history-block__Hrx_G","wrapper":"HistoryBlock_wrapper__shxdd","cards":"HistoryBlock_cards__ZoVoe","cards-wrapper":"HistoryBlock_cards-wrapper__crSZn"};